import {VereinsbeitraegeComponent} from 'kkm-library';
import {MatCardModule} from '@angular/material/card';
import {Component} from '@angular/core';

@Component({
    templateUrl: './anmeldung-satzung-page.component.html',
    styleUrls: ['./anmeldung-satzung-page.component.scss'],
    imports: [MatCardModule, VereinsbeitraegeComponent],
})
export class AnmeldungSatzungPageComponent {}
